var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_23736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_350_23736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_350_23736)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00002 11.75C0.997384 10.3376 1.27364 8.9385 1.81295 7.63306C2.35225 6.32762 3.14399 5.1415 4.14274 4.14274C5.1415 3.14399 6.32762 2.35225 7.63306 1.81295C8.9385 1.27364 10.3376 0.997384 11.75 1.00002C14.6701 1.00349 17.4952 2.03797 19.727 3.92102C20.1757 4.29083 20.6008 4.68827 21 5.11102V3.75002C21 3.55111 21.079 3.36034 21.2197 3.21969C21.3603 3.07904 21.5511 3.00002 21.75 3.00002C21.9489 3.00002 22.1397 3.07904 22.2803 3.21969C22.421 3.36034 22.5 3.55111 22.5 3.75002V7.25002C22.5 7.44893 22.421 7.6397 22.2803 7.78035C22.1397 7.921 21.9489 8.00002 21.75 8.00002H18.25C18.0511 8.00002 17.8603 7.921 17.7197 7.78035C17.579 7.6397 17.5 7.44893 17.5 7.25002C17.5 7.05111 17.579 6.86034 17.7197 6.71969C17.8603 6.57904 18.0511 6.50002 18.25 6.50002H20.237C19.7878 5.98794 19.2983 5.51275 18.773 5.07902C16.8101 3.41679 14.3222 2.50316 11.75 2.50002C10.5346 2.49738 9.33053 2.73484 8.20708 3.19876C7.08363 3.66268 6.06287 4.34393 5.2034 5.2034C4.34393 6.06287 3.66268 7.08363 3.19876 8.20708C2.73484 9.33053 2.49738 10.5346 2.50002 11.75C2.50002 11.9489 2.421 12.1397 2.28035 12.2803C2.1397 12.421 1.94893 12.5 1.75002 12.5C1.55111 12.5 1.36034 12.421 1.21969 12.2803C1.07904 12.1397 1.00002 11.9489 1.00002 11.75ZM21.75 11C21.9489 11 22.1397 11.079 22.2803 11.2197C22.421 11.3603 22.5 11.5511 22.5 11.75C22.5 14.6011 21.3674 17.3354 19.3514 19.3514C17.3354 21.3674 14.6011 22.5 11.75 22.5C9.11483 22.4164 6.60122 21.3718 4.68302 19.563C4.26891 19.1963 3.87405 18.8085 3.50002 18.401V19.75C3.50002 19.9489 3.421 20.1397 3.28035 20.2803C3.1397 20.421 2.94893 20.5 2.75002 20.5C2.55111 20.5 2.36034 20.421 2.21969 20.2803C2.07904 20.1397 2.00002 19.9489 2.00002 19.75V16.25C2.00002 16.0511 2.07904 15.8603 2.21969 15.7197C2.36034 15.579 2.55111 15.5 2.75002 15.5H6.25002C6.44893 15.5 6.6397 15.579 6.78035 15.7197C6.921 15.8603 7.00002 16.0511 7.00002 16.25C7.00002 16.4489 6.921 16.6397 6.78035 16.7803C6.6397 16.921 6.44893 17 6.25002 17H4.26202C4.69864 17.5117 5.17081 17.9918 5.67502 18.437C7.31951 20.0039 9.48014 20.9155 11.75 21C14.2033 21 16.556 20.0255 18.2908 18.2908C20.0255 16.556 21 14.2033 21 11.75C21 11.5511 21.079 11.3603 21.2197 11.2197C21.3603 11.079 21.5511 11 21.75 11Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_23736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.e0fab22ea6c0844d6dbbfc75e1a64d0a.svg";
export { ForwardRef as ReactComponent };